import { cn } from '../../lib/utils';

export type Severity = 'info' | 'warn' | 'alert' | 'positive';

const colors: Record<Severity, string> = {
  info: 'bg-foreground-muted',
  warn: 'bg-warning',
  alert: 'bg-error',
  positive: 'bg-primary',
};

interface StatusPipProps {
  severity: Severity;
  label: string;
  className?: string;
}

/**
 * Per DESIGN.md severity pip system: 8px dot + ALWAYS-visible text label.
 * One pip per card, no full-card tinting, no left-border accents.
 */
export function StatusPip({ severity, label, className }: StatusPipProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-wide', className)}
      aria-label={label.toLowerCase()}
    >
      <span className={cn('size-2 rounded-full shrink-0', colors[severity])} />
      <span>{label}</span>
    </span>
  );
}

export function statusPipForSubmission(status: string): { severity: Severity; label: string } {
  switch (status) {
    case 'FINALIZED': return { severity: 'positive', label: 'FINALIZED' };
    case 'DRAFT':     return { severity: 'info',     label: 'DRAFT' };
    case 'VOIDED':    return { severity: 'alert',    label: 'VOIDED' };
    default:          return { severity: 'info',     label: status };
  }
}

export function statusPipForPeriod(status: string): { severity: Severity; label: string } {
  switch (status) {
    case 'OPEN':      return { severity: 'info',     label: 'OPEN' };
    case 'LOCKED':    return { severity: 'positive', label: 'LOCKED' };
    default:          return { severity: 'info',     label: status };
  }
}
